import React from "react";
import { Link } from "react-router-dom";
import "./NotFoundPage.css";

function UnauthorizedPage() {
  return (
    <main className="not-found-page">
      <section className="not-found-card">
        <p className="not-found-code">403</p>
        <h1 className="not-found-title">Access Denied</h1>
        <p className="not-found-message">
          You do not have permission to view this page.
        </p>
        <Link className="not-found-home-link" to="/">
          Go Back Home
        </Link>
      </section>
    </main>
  );
}

export default UnauthorizedPage;
